<template>
  <div class="confirm">
    <div class="common-header">
      <es-breadcrumb>
        <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
        <es-breadcrumb-item>{{ $t('开票') }}</es-breadcrumb-item>
      </es-breadcrumb>
      <span class="common-header-tip">{{ $t('提示：可能有部分金额已开过发票，此处不计入可开票金额内。') }}</span>
    </div>
    <divided />

    <div class="body-card">
      <div class="tip">
        <div>
          <span>{{ type == 1 ? $t('开票总金额：') : $t('合并开票总金额：') }}</span>
          <span class="common-money">{{ price }}</span>
          &nbsp;{{ $t('元') }}
        </div>

        <div>
          <span>{{ type == 1 ? $t('开票订单：') : $t('合并开票订单：') }}</span>
          {{
            $t('{slot1}笔', {
              slot1: orderList.length,
            })
          }}
          <span v-show="showOrderTips">
            &nbsp;{{
              $t('（其中 {slot1}，将按归属公司分别合并开票）', {
                slot1: companyOrderTips,
              })
            }};&nbsp;
          </span>
        </div>
      </div>
      <Invoice :title="$t(`开票信息`)" ref="Invoice" @getInfo="getInfo" :money="price" :showAddress="showAddress">
        <div class="infoBody">
          <es-form
            :model="form"
            :rules="form.invoiceType === 2 ? rules : {}"
            ref="ruleForm"
            label-width="100px"
            class="ruleForm"
            label-position="left">
            <div class="left">
              <es-form-item :label="$t(`发票抬头:`)">
                <span class="content">{{ userInfo.name }}</span>
              </es-form-item>
              <es-form-item :label="$t(`纳税人识别号:`)" prop="identifyNumber" v-if="isOrg">
                <es-input v-model="form.identifyNumber" :placeholder="$t(`请输入内容`)" style="width: 380px"></es-input>
              </es-form-item>
              <es-form-item :label="$t(`发票类型:`)">
                <es-select v-model="form.invoiceType" :placeholder="$t(`请选择`)" v-if="isOrg" @change="changeInvoice">
                  <es-option :label="$t(`增值税普通发票`)" :value="1"></es-option>
                  <es-option :label="$t(`增值税专用发票`)" :value="2"></es-option>
                </es-select>
                <span v-else class="content">{{ $t('增值税普通发票') }}</span>
              </es-form-item>
              <es-form-item :label="$t(`发票形式:`)">
                <es-radio-group v-model="form.invoiceForm">
                  <es-radio :label="1" v-if="form.invoiceForm == 1">{{ $t('电子发票') }}</es-radio>
                  <es-radio :label="2" v-if="form.invoiceForm == 2">{{ $t('纸质发票') }}</es-radio>
                </es-radio-group>
              </es-form-item>
            </div>
            <div class="right">
              <div class="inline-block">
                <es-form-item :label="$t(`开户银行`)" prop="bank">
                  <es-select
                    v-model="form.bank"
                    filterable
                    clearable
                    remote
                    :placeholder="$t(`请选择开户银行`)"
                    :remote-method="remoteMethod"
                    :loading="searchLoading">
                    <es-option v-for="item in bankList" :key="item.id" :label="item.subBankName" :value="item.subBankName"></es-option>
                  </es-select>
                </es-form-item>
                <es-form-item :label="$t(`银行账号`)" prop="bankAccount">
                  <es-input
                    v-model="form.bankAccount"
                    :placeholder="$t(`请输入内容`)"
                    maxlength="30"
                    @input="changeBankAccount()"></es-input>
                </es-form-item>
              </div>
              <es-form-item :label="$t(`开票地址`)" prop="invoiceAddress">
                <es-input
                  v-model="form.invoiceAddress"
                  :placeholder="$t(`请输入内容`)"
                  style="width: 480px"
                  maxlength="100"
                  @input="handleInvoiceAddressInput"></es-input>
              </es-form-item>
              <es-form-item :label="$t(`开票电话`)" prop="invoiceTelephone">
                <es-input
                  v-model="form.invoiceTelephone"
                  :placeholder="$t(`开票电话，例:18899990000 或 0571-12345678-001 或 400-888-8888`)"
                  style="width: 480px"
                  maxlength="128"
                  type="tel"></es-input>
              </es-form-item>
              <es-form-item v-if="form.invoiceType === 2 && form.invoiceForm === 1" :label="$t(`接收邮箱`)" prop="invoiceEmail">
                <es-input
                  v-model="form.invoiceEmail"
                  :placeholder="$t(`电子票开具后，我们会直接通过邮件向您发送对应票据`)"
                  style="width: 480px"
                  maxlength="100"
                  type="email"></es-input>
              </es-form-item>
            </div>
          </es-form>
        </div>
      </Invoice>
      <es-form label-position="left" label-width="165px" size="mini" style="background: #f8f8f8">
        <es-form-item :label="$t(`开票备注（发票中体现）:`)" style="padding-left: 20px">
          <es-input
            type="textarea"
            v-model="form.invoiceNote"
            maxlength="150"
            :placeholder="$t(`请填写开票备注信息，发票开具后，填写内容将体现在发票备注栏`)"
            style="width: 960px; margin-bottom: 40px"></es-input>
        </es-form-item>
        <section
          class="send-info"
          style="width: 100%; height: auto; position: relative; top: 0; left: 0; padding: 20px 24px 0; box-sizing: border-box">
          <p class="invoice-info_p" style="color: rgb(51, 51, 51); font-size: 16px">{{ $t('票据开具要求（内容不体现在发票中）') }}</p>
          <es-form-item :label="$t(`票据开具要求（内容不体现在发票中）:`)" style="min-height: 80px; margin-top: 40px">
            <es-input
              type="textarea"
              v-model="form.invoiceRemark"
              maxlength="150"
              :placeholder="$t(`若有特殊开票注意事项，请留言，系统将根据您的需求流转至开票人员`)"
              style="width: 960px; margin-bottom: 40px"></es-input>
          </es-form-item>
        </section>
      </es-form>
      <div class="footer">
        <es-button type="primary" @click="onSubmit">{{ $t('确认提交') }}</es-button>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

/* eslint-disable */
import { debounce } from '@/util.js'
import { mapState } from 'vuex'
import divided from '../../components/divided'
import Invoice from '../../components/invoice'
import mixin from './mixin'
export default {
  components: {
    Invoice,
    divided,
  },
  mixins: [mixin],
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
    }),
  },
  data() {
    return {
      isDeliver: 0,
      showAddress: '',
      invoiceDisable: false,
      Taxpayer: '',
      bankList: [],
      bank: '',
      form: {
        invoiceAddress: '',
        invoiceForm: 1,
        invoiceEmail: '',
        invoiceTelephone: '',
        bank: '',
        invoiceType: 0,
        identifyNumber: '',
        bankAccount: '',
        invoiceRemark: '',
        invoiceNote: '',
      },
      InvoiceData: {},
      orderList: [],
      rules: {
        identifyNumber: [{ required: true, message: $t('请输入纳税人识别号'), trigger: 'blur' }],
        bank: [{ required: false, message: $t('请选择开户银行'), trigger: 'change' }],
        bankAccount: [{ required: false, message: $t('请输入银行账号'), trigger: 'blur' }],
        invoiceAddress: [{ required: false, message: $t('请输入开票地址'), trigger: 'blur' }],
        invoiceEmail: [
          { required: true, message: $t('请输入接收邮箱'), trigger: 'blur' },
          {
            type: 'email',
            message: $t('请正确填写接收邮箱'),
            trigger: ['blur', 'change'],
          },
        ],
        invoiceTelephone: [
          { required: false, message: $t('请填写开票电话'), trigger: 'blur' },
          {
            type: 'string',
            trigger: 'blur',
            message: $t('请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888'),
            pattern: /^((?:(?:(\+)|(00))86)?1\d{10})$|^([48]00-?\d{3}-?\d{4})$|^((?:0\d{2,3}-)?(\d{5,8}(-\d{3,5})?))$/,
          },
        ],
      },
      price: 0,
      searchLoading: false,
      invoiceType: {
        // 普通发票
        normalInvoiceForm: 'ELECTRON', // PAPER-纸质; ELECTRON-电子
        // 特殊发票
        specialInvoiceForm: 'ELECTRON', // PAPER-纸质; ELECTRON-电子
      },
    }
  },
  watch: {
    form: {
      handler(value) {
        if (value.invoiceForm === 2) {
          this.showAddress = true
        } else {
          this.showAddress = false
        }
      },
      deep: true,
    },
  },
  created() {
    this.form.invoiceType = 1
    if (this.isOrg) {
      this.getorgGetInfo()
    }
    this.type = this.$route.query.type
    this.orderList = JSON.parse(window.sessionStorage.getItem('orderList')) || []
    this.orderList.forEach(item => {
      if (item.isDeliver === 1) {
        this.isDeliver = 1
      }
      item.showPrice = parseFloat((item.price - (item.invoiceTotal || 0)).toFixed(2))
      this.price += item.showPrice
    })
    this.price = this.price.toFixed(2)
    this.getInvoiceType(this.orderList[0])
  },
  methods: {
    handleInvoiceAddressInput(e) {
      this.form.invoiceAddress = e.replace(' ', '')
    },

    // 获取开票配置类型
    getInvoiceType(obj) {
      if (obj) {
        this.$ajax(this.$url.getInvoiceType(), {
          contractId: obj.contractId ? obj.contractId : '',
          companyCode: obj.companyCode ? obj.companyCode : '',
        }).then(res => {
          this.invoiceType.normalInvoiceForm = res.data.normalInvoiceForm
          this.invoiceType.specialInvoiceForm = res.data.specialInvoiceForm
          this.form.invoiceForm = res.data.normalInvoiceForm === 'PAPER' ? 2 : 1
        })
      }
    },

    // 银行账户校验
    changeBankAccount() {
      this.form.bankAccount = this.form.bankAccount.replace(/[^0-9]/g, '')
    },
    // 根据支行名称获取银行信息
    getBankInfoBySubName(subBankName) {
      const self = this
      this.$ajax(this.$url.getBankInfoBySubName(), {
        subBankName,
      })
        .then(res => {
          self.bankList = res.data.list
          self.searchLoading = false
        })
        .catch(err => (self.searchLoading = false))
    },
    // 开户银行 远程搜索的方法
    remoteMethod(query) {
      if (query && query.trim()) {
        this.searchLoading = true
        this.getBankInfoBySubName(query.trim())
      }
    },
    getorgGetInfo() {
      this.$ajax(this.$url.orgGetInfo()).then(res => {
        this.form.identifyNumber =
          res.data.prop.credentials.usccCode ||
          res.data.prop.credentials.taxCode ||
          res.data.prop.credentials.regCode ||
          res.data.prop.credentials.orgCode
      })
    },
    // 发票类型的改变
    changeInvoice(val) {
      // 发票类型为普通发票不做校验
      // 优化切换发票类型 不展示校验信息
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
      if (val === 2) {
        this.form.invoiceForm = this.invoiceType.specialInvoiceForm === 'ELECTRON' ? 1 : 2
      } else {
        this.form.invoiceForm = this.invoiceType.normalInvoiceForm === 'ELECTRON' ? 1 : 2
      }
    },
    // 开票信息
    getInfo(val) {
      this.InvoiceData = val
    },
    // 确认提交
    onSubmit: debounce(
      function onSubmit() {
        const regexp = /^((?:(?:(\+)|(00))86)?1\d{10})$|^([48]00-?\d{3}-?\d{4})$|^((?:0\d{2,3}-)?(\d{5,8}(-\d{3,5})?))$/
        const regEx = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (this.price == 0) {
          return this.$message.error($t('开票金额不能为0!'))
        }

        // 普通发票提交时的前端校验，开户银行+银行账户
        if ((this.form.bank === '' && this.form.bankAccount) || (this.form.bank && this.form.bankAccount === '')) {
          this.$message.error($t('开票银行名称和开票银行账户需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息'))

          return false
        }

        // 开票地址+开票电话
        if (
          (this.form.invoiceAddress === '' && this.form.invoiceTelephone) ||
          (this.form.invoiceAddress && this.form.invoiceTelephone === '')
        ) {
          this.$message.error($t('开票地址和开票电话需要同时输入或是同时为空，您已输入其中一条信息，请填写完整信息'))

          return false
        } else if (this.form.invoiceTelephone && !regexp.test(this.form.invoiceTelephone)) {
          this.$message.error($t('请正确填写联系号码：例如：18899990000 或 0571-12345678-001 或 400-888-8888'))

          return false
        }
        // 接收邮箱
        if (this.form.invoiceType === 2 && this.form.invoiceForm === 1) {
          if (this.form.invoiceEmail && !regEx.test(this.form.invoiceEmail)) {
            this.$message.error($t('请正确填写接收邮箱'))

            return false
          }
        }
        // 开票地址+开票电话不超过100字符
        let count = 0
        if (this.form.invoiceAddress) {
          for (let i = 0; i < this.form.invoiceAddress.length; i++) {
            if (this.form.invoiceAddress.charCodeAt(i) > 255) {
              count += 2
            } else {
              count++
            }
          }
        }
        if (String(this.form.invoiceTelephone).length + count > 100) {
          this.$message.error($t('开票地址过长，系统无法支持，建议字数控制在40个字以内'))
          return false
        }

        if (this.price >= 2000000 && this.form.invoiceType === 1) {
          this.$message.error($t('抱歉，单次发票可开具金额为1999999.99，请联系客服获取发票。'))

          return
        }
        const list = []
        this.orderList.forEach(item => {
          list.push({
            orderId: item.id,
            invoiceAmount: item.showPrice,
            contractId: item.contractId,
          })
        })
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            const data = {
              customerName: this.userInfo.name,
              customerType: this.isOrg ? 1 : 0,
              bank: this.form.bank,
              bankAccount: this.form.bankAccount,
              expressPayMethod: this.InvoiceData.expressType,
              fee: (this.price < 1000 || this.InvoiceData.expressType === 2) && this.form.invoiceForm === 2 ? this.InvoiceData.fee : 0,
              invoiceForm: this.form.invoiceForm,
              invoiceType: this.form.invoiceType,
              list,
              identifyNumber: this.form.identifyNumber,
              invoiceTitleName: this.userInfo.name,
              receivePhone: this.form.invoiceForm === 1 ? '' : this.InvoiceData.address ? this.InvoiceData.address.contactNumber : '',
              receiveAddress: this.form.invoiceForm === 1 ? '' : this.InvoiceData.address ? this.InvoiceData.address.addressAll : '',
              receiver: this.form.invoiceForm === 1 ? '' : this.InvoiceData.address ? this.InvoiceData.address.contact : '',
              invoiceAddress: this.form.invoiceAddress,
              invoiceTelephone: this.form.invoiceTelephone,
              invoiceRemark: this.form.invoiceRemark,
              invoiceNote: this.form.invoiceNote,
              email: this.form.invoiceEmail,
            }
            this.$ajax(this.$url.invoiceCombine(), data).then(res => {
              if (res.success) {
                sessionStorage.setItem('orderList', null)
                if (this.price < 1000 && this.InvoiceData.expressType !== 2 && this.form.invoiceForm === 2) {
                  const { invoiceResponses = [] } = res.data
                  const [first] = invoiceResponses
                  this.$router.push({
                    path: '/RechargeOnline',
                    query: {
                      invoiceId: first.invoiceId,
                      fee: this.InvoiceData.fee,
                      invoiceOnline: 0,
                    },
                  })
                } else {
                  this.$router.push({
                    path: '/InvoiceResult',
                    query: {
                      invoiceForm: this.form.invoiceForm,
                      combineCode: res.data.combineCode,
                    },
                  })
                }
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      },
      2000,
      true
    ),
  },
}
</script>
<style lang="less" scoped>

.footer {
  margin-top: 20px;

}

.content {
  font-size: 14px;
  color: #1a1a1a;
}
.infoBody {
  display: flex;
  .ruleForm {
    display: flex;
    width: 100%;
    div.left,
    div.right {
      flex: 1;
      > div {
        height: 30px;
        line-height: 30px;
        display: flex;
        margin-bottom: 20px;
      }
    }
    div.right {
      .inline-block {
        > div {
          height: 30px;
          line-height: 30px;
          margin-right: 50px;
        }
      }
    }
  }
}

/deep/ .es-form-item.is-required > .es-form-item__label:before {
  content: '';
  margin-right: 0;
}
.body-card {
  padding: 24px;
  .invoice {
    padding-bottom: 0;
  }
  .tip {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    font-size: 14px;
    color: #1a1a1aff;
    div {
      margin-right: 120px;
      > span:first-child {
        margin-right: 26px;
      }
    }
  }
}
</style>
